import { ResponseData } from "src/app/@types/interfaces/get.response";
import { CoreService } from "./core.service";
import youthRequests from "src/app/data/youth-requests.json";
import enrolledPrograms from "src/app/data/enrolled-programs.json";
import defaultEnrolledPrograms from "src/app/data/default-enrolled-programs.json";
import programSalaryDetails from "src/app/data/salary-details.json";
import { EnrolledProgram, ProgramSalaryDetail, YouthRequest } from "src/app/interfaces/my.youth";

interface YouthRequestResponse {
    requests: YouthRequest[];
}

interface EnrolledProgramsResponse {
    programs: EnrolledProgram[];
}

interface ProgramDetailsResponse {
    salaryDetails: ProgramSalaryDetail[];
}

class MyYouthService extends CoreService {

    async getYouthRequests(): Promise<ResponseData<YouthRequestResponse>> {
        return new Promise((resolve, reject) => {
            try {
                const response: ResponseData<YouthRequestResponse> = {
                    success: true,
                    message: "Youth requests retrieved successfully",
                    data: { requests: youthRequests as YouthRequest[] },
                };
                resolve(response);
            } catch (error) {
                const errorMessage =
                    error instanceof Error
                        ? error.message
                        : "Failed to load youth requests";
                reject(new Error(errorMessage));
            }
        });
    }

    async getEnrolledPrograms(): Promise<ResponseData<EnrolledProgramsResponse>> {
        return new Promise((resolve, reject) => {
            try {
                const response: ResponseData<EnrolledProgramsResponse> = {
                    success: true,
                    message: "Enrolled programs retrieved successfully",
                    data: { programs: enrolledPrograms as EnrolledProgram[] },
                };
                resolve(response);
            } catch (error) {
                const errorMessage =
                    error instanceof Error
                        ? error.message
                        : "Failed to load enrolled programs";
                reject(new Error(errorMessage));
            }
        });
    }

    async getDefaultEnrolledPrograms(): Promise<ResponseData<EnrolledProgramsResponse>> {
        try {
            const data: EnrolledProgram[] = defaultEnrolledPrograms as any[];
            return {
                success: true,
                message: 'Enrolled programs retrieved successfully',
                data: { programs: data },
            };
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : 'Failed to load enrolled programs';
            throw new Error(errorMessage);
        }
    }

    async getSalaryDetails(): Promise<ResponseData<ProgramDetailsResponse>> {
        try {
            const data: ProgramSalaryDetail[] = programSalaryDetails as any[];
            return {
                success: true,
                message: 'Programs retrieved successfully',
                data: { salaryDetails: data },
            };
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : 'Failed to load programs';
            throw new Error(errorMessage);
        }
    }
}

export const myYouthService = new MyYouthService();
